module.exports = __webpack_public_path__ + "media/file.48fe3e7a.mp3";